var _path, _circle, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoprojectfounddark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 89,
    viewBox: "0 0 156 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.003 11.4253C152.591 11.4253 155.5 14.3497 155.5 17.957C155.5 21.5644 152.591 24.4888 149.003 24.4888H111.877C115.465 24.4888 118.374 27.4131 118.374 31.0205C118.374 34.6279 115.465 37.5523 111.877 37.5523H132.296C135.885 37.5523 138.793 40.4766 138.793 44.084C138.793 47.6914 135.885 50.6157 132.296 50.6157H122.854C118.329 50.6157 114.662 53.5401 114.662 57.1475C114.662 59.5524 116.518 61.7297 120.231 63.6792C123.819 63.6792 126.728 66.6036 126.728 70.211C126.728 73.8184 123.819 76.7427 120.231 76.7427H43.1946C39.6064 76.7427 36.6976 73.8184 36.6976 70.211C36.6976 66.6036 39.6064 63.6792 43.1946 63.6792H6.99701C3.40881 63.6792 0.5 60.7549 0.5 57.1475C0.5 53.5401 3.40881 50.6157 6.99701 50.6157H44.1228C47.711 50.6157 50.6198 47.6914 50.6198 44.084C50.6198 40.4766 47.711 37.5523 44.1228 37.5523H20.9192C17.331 37.5523 14.4222 34.6279 14.4222 31.0205C14.4222 27.4131 17.331 24.4888 20.9192 24.4888H58.0449C54.4567 24.4888 51.5479 21.5644 51.5479 17.957C51.5479 14.3497 54.4567 11.4253 58.0449 11.4253H149.003ZM149.003 37.5523C152.591 37.5523 155.5 40.4766 155.5 44.084C155.5 47.6914 152.591 50.6157 149.003 50.6157C145.415 50.6157 142.506 47.6914 142.506 44.084C142.506 40.4766 145.415 37.5523 149.003 37.5523Z",
    fill: "#2B2E31"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9352,
    cy: 71.9901,
    r: 4.65882,
    fill: "#2B2E31"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.8595,
    cy: 37.0018,
    rx: 25.8468,
    ry: 25.9356,
    fill: "#BFC4CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3941 40.4633C61.8659 40.4633 63.1113 39.2136 63.1113 37.7366C63.1113 36.2597 61.8659 35.01 60.3941 35.01C58.9222 35.01 57.6768 36.2597 57.6768 37.7366C57.6768 39.2136 58.9222 40.4633 60.3941 40.4633Z",
    fill: "#91979D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2271 40.4633C82.6989 40.4633 83.9443 39.2136 83.9443 37.7366C83.9443 36.2597 82.6989 35.01 81.2271 35.01C79.7552 35.01 78.5098 36.2597 78.5098 37.7366C78.5098 39.3272 79.7552 40.4633 81.2271 40.4633Z",
    fill: "#91979D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 28.7135L54.3115 31.9521L55.1184 33.4517L61.096 30.213L60.2891 28.7135Z",
    fill: "#91979D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8584 28.6708L80.0518 30.1704L86.0297 33.4082L86.8364 31.9086L80.8584 28.6708Z",
    fill: "#91979D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8108 46.8241C72.5616 46.8241 73.981 45.7559 73.981 44.4383C73.981 43.1206 72.5616 42.0525 70.8108 42.0525C69.06 42.0525 67.6406 43.1206 67.6406 44.4383C67.6406 45.7559 69.06 46.8241 70.8108 46.8241Z",
    fill: "#91979D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 71.7605L87.292 56.584L90.7555 53.1021L105.851 68.2906L102.4 71.7605Z",
    fill: "#5D6373"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.924 79.3849L98.3398 67.7384C97.3724 66.7659 97.3724 65.181 98.3398 64.2084C99.3072 63.2359 100.884 63.2359 101.851 64.2084L113.436 75.855C114.403 76.8275 114.403 78.4124 113.436 79.3849C112.468 80.3575 110.892 80.3575 109.924 79.3849Z",
    fill: "#5D6373"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.099 80.1314L94.1943 65.147C93.848 64.7988 93.848 64.2345 94.1943 63.8743L98.0041 60.0441C98.3505 59.6959 98.9118 59.6959 99.2701 60.0441L114.175 75.0285C114.521 75.3767 114.521 75.941 114.175 76.3012L110.365 80.1314C110.007 80.4796 109.446 80.4796 109.099 80.1314Z",
    fill: "url(#paint0_linear_31762_229753)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1918 7.68213C54.3793 7.68213 41.5645 20.5654 41.5645 36.4623C41.5645 52.3472 54.3793 65.2425 70.1798 65.2425C85.9923 65.2425 98.8071 52.3592 98.8071 36.4623C98.8071 20.5654 85.9923 7.68213 70.1918 7.68213ZM70.1918 59.9115C57.4964 59.9115 47.2135 49.4056 47.2135 36.4503C47.2135 23.495 57.4964 13.0011 70.1918 13.0011C82.8871 13.0011 93.1701 23.507 93.1701 36.4623C93.1701 49.4176 82.8752 59.9115 70.1918 59.9115Z",
    fill: "url(#paint1_linear_31762_229753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31762_229753",
    x1: 93.9252,
    y1: 70.09,
    x2: 114.438,
    y2: 70.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8892A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31762_229753",
    x1: 41.5382,
    y1: 36.4686,
    x2: 98.8176,
    y2: 36.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8892A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7686"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoprojectfounddark);
export default __webpack_public_path__ + "static/media/noprojectfounddark.d9c3561a962b7b6d3f489e72b9f435db.svg";
export { ForwardRef as ReactComponent };